import React from 'react';
import {
  FileSyncAppLink,
  RolesAndAccessControlLink,
  StartFreeTrail,
} from 'constants/subscription';
import { Plan, PlanCost, PlanName } from './Plan';

type TeamPlanProps = {
  isActivePlan?: boolean;
  teamChooseText?: string;
  onSelect: () => void;
};

export const TeamPlan = ({
  isActivePlan,
  teamChooseText,
  onSelect,
}: TeamPlanProps) => {
  return (
    <Plan
      name='Pro'
      planColor='#0F2EFF'
      dataTestId='choosePlanPage-pro-button'
      description={
        <span>
          Team workspace incl everything
          <p>
            in <span className='text-gray-400 font-bold'>Starter</span> plus:
          </p>
        </span>
      }
      cost={<PlanCost size='small'>€20 per user/month</PlanCost>}
      details='Billed annually or €25 monthly'
      features={[
        <div key='one-of-a-kind-100cs'>100 GB of private Cloud Storage</div>,
        'Unlimited version control history',
        'Unlimited CAD conversions',
        'Unlimited CAD chat history',
        'Unlimited annotations',
        <div key='one-of-a-kind-10adm'>10 AutoDFM/Month (coming soon)</div>,
        'Simplified billing per seat',
        <span key='role'>
          Team{' '}
          <a href={RolesAndAccessControlLink} target='_blank' rel='noreferrer'>
            Roles & Access Controls
          </a>
        </span>,
        'Customer support(chat, email)',
      ]}
      isActivePlan={isActivePlan}
      buttonText={teamChooseText || StartFreeTrail}
      buttonVariant='primary'
      onSelect={onSelect}
    />
  );
};
